import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { Amplify } from 'aws-amplify';
import { Hub } from 'aws-amplify/utils';
import { fetchAuthSession, fetchUserAttributes } from '@aws-amplify/auth';
import * as Sentry from "@sentry/react";
// Holy shit. when I had it like this:
// import { Amplify } from '@aws-amplify/core';
// it failed with "Auth UserPool not configured"

console.log(process.env.ENVIRONMENT);

// Sentry is disabled when ENVIRONMENT=local (or unset) — only active in deployed environments.
if (process.env.ENVIRONMENT && process.env.ENVIRONMENT !== 'local') {
  Sentry.init({
    dsn: "https://864250798e21e90bd3cace37fd885ad4@o4509865969188864.ingest.us.sentry.io/4511216506634240",
    environment: process.env.ENVIRONMENT,
    // Capture user IPs and automatic IP collection
    sendDefaultPii: true,
    integrations: [
      // Automatic page-load and navigation performance traces.
      // Instruments fetch/XHR, measures LCP/FCP/CLS, tracks route changes.
      Sentry.browserTracingIntegration(),
      // User feedback form — autoInject disabled so we trigger it from our own
      // bug-report button in the sidebar rather than a floating widget.
      Sentry.feedbackIntegration({
        autoInject: false,
        enableScreenshot: true,
        colorScheme: 'dark',
      }),
    ],
    // Sample 10% of transactions for performance monitoring.
    // Adjust down if volume is high; 0 to disable performance tracing entirely.
    tracesSampleRate: 0.1,
    // Extract workspace_id from the URL at event-send time so it's always current.
    beforeSend(event) {
      const match = window.location.pathname.match(/\/workspaces\/([^/]+)/);
      if (match) {
        event.tags = { ...event.tags, workspace_id: match[1] };
      }
      return event;
    },
  });

  // Set Sentry user on initial load in case the session is already active (page refresh).
  fetchAuthSession().then(session => {
    if (session.tokens?.idToken) {
      fetchUserAttributes().then(attrs => {
        Sentry.setUser({ id: attrs.sub, email: attrs.email });
      }).catch(() => { });
    }
  }).catch(() => { });

  // Keep Sentry user in sync with Amplify auth events (sign-in / sign-out).
  Hub.listen('auth', async ({ payload }) => {
    if (payload.event === 'signedIn') {
      try {
        const attrs = await fetchUserAttributes();
        Sentry.setUser({ id: attrs.sub, email: attrs.email });
      } catch { }
    } else if (payload.event === 'signedOut') {
      Sentry.setUser(null);
    }
  });
}

// Configure Amplify
const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.COGNITO_USER_POOL_ID || 'missing COGNITO_USER_POOL_ID',
      userPoolClientId: process.env.COGNITO_CLIENT_ID || 'missing COGNITO_CLIENT_ID',
      loginWith: {
        oauth: {
          domain: process.env.COGNITO_DOMAIN || 'missing COGNITO_DOMAIN',
          scopes: ['openid', 'email', "profile"],
          redirectSignIn: [`${process.env.BASE_URL}/auth/callback/cognito`],
          redirectSignOut: [`${process.env.BASE_URL}/`],
          responseType: 'code' as const
        },
        username: false,
        email: true,
        phone: false
      }
    }
  }
};

// console.log('Configuring Amplify with:', amplifyConfig);
Amplify.configure(amplifyConfig);
// console.log("Amplify configured", Amplify.getConfig())

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
